import { render, staticRenderFns } from "./BaseTableHeader.vue?vue&type=template&id=72f26938&lang=pug"
import script from "./BaseTableHeader.vue?vue&type=script&lang=js"
export * from "./BaseTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports